<template>
    <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
        <b-tabs id="tabsMagazzino" ref="tabsMagazzino" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
            <b-tab>
                <template #title> <i class="fas fa-stream"></i><span style="padding-left: 10px">Anagrafica</span> </template>
                <component :is="currentAnagraficaComponent" @updateJsonData="onUpdateJsonData" @tipoArticolo="onTipoArticolo" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" ref="cmpMagazzinoArticoliAnagrafica" />
            </b-tab>
            <b-tab lazy>
                <template #title> <i class="fas fa-barcode"></i><span style="padding-left: 10px">Codici</span> </template>
                <p>Tab Due</p>
            </b-tab>
            <b-tab v-if="isFarmaco" id="bancaFarmaci">
                <template #title> <i class="fas fa-book-medical"></i><span style="padding-left: 10px">Scheda Farmaco</span> </template>
                <banca-farmaci-view-component ref="cmpBancaFarmaciView" />
                <p>Tab Due</p>
            </b-tab>
            <b-tab v-if="isView" lazy>
                <template #title> <i class="fas fa-truck-moving"></i><span style="padding-left: 10px">Fornitori</span> </template>
                <magazzino-articoli-fornitori-list-component />
            </b-tab>
            <b-tab lazy>
                <template #title> <i class="fas fa-paperclip"></i><span style="padding-left: 10px">Allegati</span> </template>
                <p>Tab Tre</p>
            </b-tab>
        </b-tabs>
    </b-card>
</template>

<script>
import MagazzinoArticoliAnagraficaEditComponent from "./MagazzinoArticoliAnagraficaEditComponent.vue";
import MagazzinoArticoliViewComponent from "./MagazzinoArticoliViewComponent.vue";
import MagazzinoArticoliFornitoriListComponent from "./MagazzinoArticoliFornitoriListComponent.vue";
import BancaFarmaciViewComponent from "../../bancafarmaci/components/BancaFarmaciViewComponent.vue";
export default {
    name: "MagazzinoArticoliEditComponent",
    components: { MagazzinoArticoliAnagraficaEditComponent, MagazzinoArticoliViewComponent, MagazzinoArticoliFornitoriListComponent, BancaFarmaciViewComponent },
    data() {
        return {
            activeTabIndex: 0,
            btnSaveVisible: true,
            showModalLoading: false,
            linkback: "/magazzino/articoli",
            pathResource: "/magazzinoarticoli",
            jsonData: null,
            isFarmaco: false,
            isView: false,
            codiceArticolo: null,
            id: null,
        };
    },
    computed: {
        // Determina quale componente usare basandosi sulla route
        currentAnagraficaComponent() {
            if (this.isView) {
                return "MagazzinoArticoliViewComponent";
            }
            return "MagazzinoArticoliAnagraficaEditComponent";
        },
    },
    mounted() {
        let me = this;
        me.isView = me.$route.path.includes("/view/");
        /* if (me.isView) {
            me.id = this.$route.params.id;
            console.log("id");
        } */
        console.log("Is View mode:", me.isView);
        /* console.log("Current component:", me.currentAnagraficaComponent);
        console.log("Route path:", me.$route.path); */
    },
    methods: {
        onUpdateJsonData(jsonData) {
            let me = this;
            me.jsonData = jsonData;
            me.codiceArticolo = jsonData.codiceArticolo;
            // console.log("Jsondata", jsonData);
            me.$emit("updateJsonData", jsonData);
        },

        onTipoArticolo(farmaco) {
            let me = this;
            me.isFarmaco = farmaco;
        },
        /* onSalvaAnagraficaArticolo() {
            let me = this;
            me.$refs.cmpMagazzinoArticoliAnagraficaEdit.salvaAnagraficaArticolo();
        }, */

        onBeforeLoadData() {
            let me = this;
            me.$emit("beforeLoadData");
        },
        onAfterLoadData() {
            let me = this;
            me.$emit("afterLoadData");
        },
        onInputTabs(index) {
            let me = this;
            let indexTab = me.$refs.tabsMagazzino.getTabs()[index];
            me.activeTab(indexTab.id);
            /* console.log("index", index);
            console.log("indexTab", indexTab.id); */
        },
        activeTab(idIndexTab) {
            let me = this;
            switch (idIndexTab) {
                case "bancaFarmaci":
                    me.$refs.cmpBancaFarmaciView.init(me.jsonData.codiceBarre);
                    console.log("OM");
                    break;
            }
        },
    },
};
</script>

<style></style>
